import { render, staticRenderFns } from "./PpeRegisterSendModal.vue?vue&type=template&id=6393f52f&"
import script from "./PpeRegisterSendModal.vue?vue&type=script&lang=js&"
export * from "./PpeRegisterSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports